import fetch from '@adc/fetch'
import configment from '@adc/configment'
import { performLogout } from '../../../util/logout'

export const fetchApplicationSessionInformation = async params => {
  const { page, take, channel = 'WEB', read, displayed } = params
  const response = await fetch.forAuctionGraph({
    query: `
         query toolkitAdc_fetchApplicationSessionInformation ($channel: NotificationChannelType!, $page: NonNegativeInt, $take: PositiveInt, $displayed: Boolean, $read: Boolean) {
           current_user {
              onboarding_answers {
               question_code
              }
              purchase_profiles {
                ... on ReoPurchaseProfile {
                  percent_complete
                }
              }
             notifications(filters: {channel: $channel, page: $page, take: $take, displayed: $displayed, read: $read }) {
               content {
                 content
                 read
                 displayed
                 message_id
                 notification_intent_code
                 created_date
               }
               total_elements
               total_count
               current_page
               total_pages
             }
           }
         }
      `,
    variables: {
      channel,
      page,
      take,
      displayed,
      read,
    },
  })
  // eslint-disable-next-line camelcase
  return response?.body.data?.current_user || {}
}

export const markAllNotificationsAsRead = () =>
  fetch.forAuctionGraph({
    query: `
      mutation toolkitAdc_markAllNotificationsAsRead {
        markAllNotificationsAsRead
      }
    `,
  })

export const clearAllNotifications = () =>
  fetch.forAuctionGraph({
    query: `
      mutation toolkitAdc_clearAllNotifications {
        clearAllNotifications
      }
    `,
  })

export const performFreshnessCheck = async loggedInRef => {
  let logout = false

  try {
    const response = await fetch.get(
      configment.get('URL_BASE_PREFIX', '') + '/fdn/session-refresh'
    )
    const sessionKey = response.body?.authentication?.session_key || 'anon:'
    const isLoggedIn = !sessionKey.startsWith('anon:')
    const pageDeploymentVersion =
      window.INITIAL_STATE?.deployment?.current_version
    const serverDeploymentVersion = response.body?.deployment?.current_version

    logout =
      // If the token has expired, we will have reverted to an anonymous session, so log out.
      (loggedInRef.current.wasLoggedIn && !isLoggedIn) ||
      // If the deployment version is known and has changed, log out.
      (pageDeploymentVersion &&
        serverDeploymentVersion &&
        pageDeploymentVersion !== serverDeploymentVersion)

    loggedInRef.current.wasLoggedIn = isLoggedIn
  } catch (e) {
    // The service used to throw a 403 when the token expired, so we log out for backwards compatibility.
    logout = e.status === 403
  }

  if (logout) {
    performLogout(window.location.pathname)
  }
}
